// modules
import { module_main } from './js/main';

module_main();
